import { render, staticRenderFns } from "./InboxAgentName.vue?vue&type=template&id=0c53e732&scoped=true&"
import script from "./InboxAgentName.vue?vue&type=script&lang=js&"
export * from "./InboxAgentName.vue?vue&type=script&lang=js&"
import style0 from "./InboxAgentName.vue?vue&type=style&index=0&id=0c53e732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c53e732",
  null
  
)

export default component.exports